module.exports = __webpack_public_path__ + "img/img13.ed41278f.jpg";